import { useEffect, useState } from 'react';
import { Button, Confirm, Dimmer, Form, FormField, Header, Icon, Input, Loader, Message } from "semantic-ui-react";
import SimpleReactValidator from 'simple-react-validator';

const ReviewPassport = (props) => {
    const getTerm = props.getTerm;

    const [errorString, setError] = useState();
    const [warnings, setWarnings] = useState([]);
    const [surname, setSurname] = useState("");
    const [givenNames, setGivenNames] = useState("");
    const [surnameError, setSurnameError] = useState(false);
    const [givenNamesError, setGivenNamesError] = useState(false);
    const [loading, setLoading] = useState(false);

    const validator = new SimpleReactValidator();
    const isUpperCase = str => str === str.toUpperCase();
    const isLowerCase = str => str === str.toLowerCase();
    const titles = ["Mr", "Mrs", "Miss", "Ms", "Mx", "Sir", "Dame", "Dr" , "Cllr", "Lady", "Lord"];
    const suffixes = ["Jr", "Sr", "II", "III", "IV", "V", "PhD", "MD", "Esq", "Esquire", "CPA", "DDS", "DVM"];
    const startsWithCapital = (str) => {
        if (!str || str.length === 0) {
            return false; // Handles empty or null/undefined strings
        }
        return str[0] === str[0].toUpperCase();
    }

    //getTerm("5e236ff0-d461-11f0-9cd9-0ac9221eb135", "Your name starts with a lowercase letter. Is this correct?")
    //getTerm("a046eea0-d526-11f0-9cd9-0ac9221eb135", "An error occurred while updating name details.")
    //getTerm("ba6da6a2-d526-11f0-9cd9-0ac9221eb135", "An error occurred while updating country and alias details")
    //getTerm("d05f9dee-d526-11f0-9cd9-0ac9221eb135", "A registration system error occurred: {message}")
    //getTerm("e5668f2c-d526-11f0-9cd9-0ac9221eb135", "Please try again or contact technical support.")

    useEffect(() => {
        // let tokenData = sessionStorage.getItem("tokenData");
        // let details = JSON.parse(tokenData).details;
        setSurname(props.participantDetails.LastName);
        setGivenNames(props.participantDetails.FirstName);
    }, []);

    const submitForm = (e) =>
    {
        setError();
        setWarnings([]);
        setSurnameError(false);
        setGivenNamesError(false);

        let hasErrors = false;
        let _warnings = [];

        // surname checks
        const testSurname = surname.replace(/\./g, '');

        if (!validator.check(surname, 'required'))
        {
            setSurnameError({ content: getTerm("cc9a7432-d13d-11f0-8346-0ac9221eb135", "Please fill out this field.") });
            hasErrors = true;
        }
        // else if (!validator.check(testSurname, 'alpha_num_dash_space'))
        // {
        //     setSurnameError({ content: getTerm("6d8ca1c8-d515-11f0-9cd9-0ac9221eb135", "Please use only Latin characters in this field. Your name includes invalid characters.") });
        //     hasErrors = true;
        // }
        else if (isUpperCase(surname))
        {
            setSurnameError({ content: getTerm("4bab95aa-d51a-11f0-9cd9-0ac9221eb135", "Please do not use all capital letters. Use Uppercase letters only when needed.") });
            hasErrors = true;
        }
        else if (isLowerCase(surname))
        {
            setSurnameError({ content: getTerm("98cac072-d51a-11f0-9cd9-0ac9221eb135", "Please capitalize your name correctly. Your name must have at least one uppercase letter.") });
            hasErrors = true;
        }
        else if (suffixes.some(v => surname.includes(v)))
        {
            const msg = getTerm("ec910922-d51b-11f0-9cd9-0ac9221eb135", "Your name includes a common title or suffix. Does this match your passport?");
            if (!_warnings.includes(msg)) {
                _warnings.push(msg);
            }
        }
        else if (!startsWithCapital(surname))
        {
            const msg = getTerm("7ae3208e-d526-11f0-9cd9-0ac9221eb135", "Your name starts with a lowercase letter. Is this correct?");
            if (!_warnings.includes(msg)) {
                _warnings.push(msg);
            }
        }

        // givenNames checks
        if (!validator.check(givenNames, 'required'))
        {
            setGivenNamesError({ content: getTerm("cc9a7432-d13d-11f0-8346-0ac9221eb135", "Please fill out this field.") });
            hasErrors = true;
        }
        // else if  (!validator.check(givenNames, 'alpha_num_dash_space'))
        // {
        //     setGivenNamesError({ content: getTerm("6d8ca1c8-d515-11f0-9cd9-0ac9221eb135", "Please use only Latin characters in this field. Your name includes invalid characters.") });
        //     hasErrors = true;
        // }
        else if (isUpperCase(givenNames))
        {
            setGivenNamesError({ content: getTerm("4bab95aa-d51a-11f0-9cd9-0ac9221eb135", "Please do not use all capital letters. Use Uppercase letters only when needed.") });
            hasErrors = true;
        }
        else if (isLowerCase(givenNames))
        {
            setGivenNamesError({ content: getTerm("98cac072-d51a-11f0-9cd9-0ac9221eb135", "Please capitalize your name correctly. Your name must have at least one uppercase letter.") });
            hasErrors = true;
        }
        else if (titles.some(v => givenNames.includes(v)))
        {
            const msg = getTerm("ec910922-d51b-11f0-9cd9-0ac9221eb135", "Your name includes a common title or suffix. Does this match your passport?");
            if (!_warnings.includes(msg)) {
                _warnings.push(msg);
            }
        }
        else if (!startsWithCapital(givenNames))
        {
            const msg = getTerm("7ae3208e-d526-11f0-9cd9-0ac9221eb135", "Your name starts with a lowercase letter. Is this correct?");
            if (!_warnings.includes(msg)) {
                _warnings.push(msg);
            }
        }

        if (_warnings.length > 0) {
            setWarnings(_warnings);
        }

        if (!hasErrors && _warnings.length == 0) {
            save();
        }
        else
        {
            if (hasErrors) {
                setWarnings([]);
                setError(getTerm("c893573c-d13d-11f0-8346-0ac9221eb135", "Please review the fields marked below."));
            }
        }
    }

    const save = () => {
        setLoading(true);

        props.dataManager.updateName(props.jwt, givenNames, surname)
            .then(response => {
                setLoading(false);
                if (typeof response.data.success !== "undefined") {
                    if (response.data.success == 0) {
                        setError(response.data.errorMessage);
                    } else {
                        // Update participantDetails with new name
                        props.participantDetails.LastName = surname.trim();
                        props.participantDetails.FirstName = givenNames.trim();
                        props.setParticipantDetails(props.setParticipantDetails);

                        props.setStep("reviewCustomization");
                    }
                }
                else
                {
                    setError(response.data);
                    setLoading(false);
                }
            });
    };

    const handleCancel = () => {
        setWarnings([]);
    };

    const handleConfirm = () => {
        setWarnings([]);
        save();
    };

    return (
        <div>
            <Dimmer active={loading} inverted>
                <Loader inverted>{getTerm("bda913ca-d13d-11f0-8346-0ac9221eb135", "Loading")}</Loader>
            </Dimmer>

            <Header as='h2' style={{marginTop: 0}}>{getTerm("7a84617e-d45f-11f0-9cd9-0ac9221eb135", "Personal Information Review: Passport-Aligned Name")}</Header>
            <div>
                <div className='passport-container'>
                    <div className='column'>
                        <p>
                            <span dangerouslySetInnerHTML={{__html: getTerm("2c848f34-d460-11f0-9cd9-0ac9221eb135", 'The IATF <strong>requires</strong> that your name in the ADP match exactly what is listed in your passport, as noted in the "Surname" and "Given names" fields. See the <span style="color: red;">red arrows</span> on the sample passport as an example.')}}></span>
                            &nbsp;&nbsp;
                            <a href="https://go.iatfadp.com/name-passport" target="_blank">{getTerm("3c969782-d460-11f0-9cd9-0ac9221eb135", "What if I don't have a passport?")}</a>
                        </p>
                        <p style={{fontSize: 17}} dangerouslySetInnerHTML={{__html: getTerm("5e236ff0-d461-11f0-9cd9-0ac9221eb135", "Take note of the following:<br /><ol><li><strong>Use Uppercase letters <em>only when needed</em></strong><br />Unlike passports, <u>do not use ALL-CAPS</u>. Inner-capitalization like \"McDonald\" is okay.<br /><br /></li><li><strong>DO only use <em>Latin</em> characters</strong><br />If you typically use other alphabets like Chinese, Japanese, or Korean, you'll be able to provide that separately on the next step.<br /><br /></li><li><strong>DO use accents, diacritics, dashes, or apostrophes if needed</strong><br />For example, \"O'Toole\", \"St-Pierre\", and \"Dvořák\" are all okay.<br /><br /></li><li><strong><em>DO NOT</em> use titles or suffixes, unless in Passport</strong><br />No title like \"Dr.\" or degrees like \"PhD\" unless shown in your passport's Surname or Given name fields.</li></ol>")}}>
                        </p>

                        <p dangerouslySetInnerHTML={{__html: getTerm("f3093b4a-f8ba-11f0-84a1-0ac9221eb135", "<strong>NOTE:</strong> Some passports have a combined name field presented in “Surname, Given Names” order, as shown below the sample passport. In this case, please enter the Latin-character rendition of your name and split it accordingly.")}}></p>
                    </div>
                    <div className='column'>
                        <img src='/images/sample_passport.png' alt="sample passport" style={{maxWidth: "100%", display: "block", margin: "auto"}}/>
                    </div>
                </div>
            </div>

            { (typeof errorString !== "undefined") &&
            <Message error icon size='tiny'>
                <Icon name='exclamation' />
                <Message.Content>
                <Message.Header>{getTerm("c2d4a314-d13d-11f0-8346-0ac9221eb135", "An error occurred")}</Message.Header>
                {errorString}
                </Message.Content>
            </Message>
            }

            {/* { (warnings.length > 0) &&
                <Message warning icon size='tiny'>
                    <Icon name='exclamation' />
                    <Message.Content>
                        <ul style={{paddingLeft: '1em'}}>
                            {warnings.map(item => <li>{item}</li>)}
                        </ul>
                        <Button onClick={handleWarningClick}>Yes</Button>
                    </Message.Content>
                </Message>
            } */}

            <Form size='large' style={{marginTop: '2em'}} onSubmit={submitForm}>

                <div style={{width: '75%', margin: "auto", fontSize: 17}}>

                    <div className="review-passport-row">
                        <div style={{flexShrink: 0}}>
                            <label style={{fontWeight: 700}}>{getTerm("9dfaa8f6-d465-11f0-9cd9-0ac9221eb135", "Surname (Last/Family Name):")}</label>
                            <br />
                            <span style={{fontSize: 14}}>{getTerm("c09ee538-d466-11f0-9cd9-0ac9221eb135", "(In Latin characters, only capitalize where needed)")}</span>
                        </div>
                        <FormField
                            // required
                            control={Input}
                            onChange={(e) => setSurname(e.target.value)} value={surname}
                            // error={{
                            //     content: 'Please enter a valid email address'
                            // }}
                            error={surnameError}
                            className="passportField"
                        />
                    </div>

                    {/* <FormField
                        // required
                        control={Input}
                        label={<><label>{getTerm("9dfaa8f6-d465-11f0-9cd9-0ac9221eb135", "Surname (Last/Family Name):")}</label><span>{getTerm("c09ee538-d466-11f0-9cd9-0ac9221eb135", "(In Latin characters, only capitalize where needed)")}</span></>}
                        onChange={(e) => setSurname(e.target.value)} value={surname}
                        // error={{
                        //     content: 'Please enter a valid email address'
                        // }}
                        error={surnameError}
                    /> */}

                    {/* <FormField
                        // required
                        control={Input}
                        label={<><label>{getTerm("ca7ce614-d465-11f0-9cd9-0ac9221eb135", "Given Names:")}</label><span>{getTerm("c09ee538-d466-11f0-9cd9-0ac9221eb135", "(In Latin characters, only capitalize where needed)")}</span></>}
                        onChange={(e) => setGivenNames(e.target.value)} value={givenNames}
                        // error={{
                        //     content: 'Please enter a valid email address'
                        // }}
                        error={givenNamesError}
                    /> */}

                    <div className="review-passport-row">
                        <div style={{flexShrink: 0}}>
                            <label style={{fontWeight: 700}}>{getTerm("ca7ce614-d465-11f0-9cd9-0ac9221eb135", "Given Names:")}</label>
                            <br />
                            <span style={{fontSize: 14}}>{getTerm("c09ee538-d466-11f0-9cd9-0ac9221eb135", "(In Latin characters, only capitalize where needed)")}</span>
                        </div>
                        <FormField
                            // required
                            control={Input}
                            onChange={(e) => setGivenNames(e.target.value)} value={givenNames}
                            // error={{
                            //     content: 'Please enter a valid email address'
                            // }}
                            error={givenNamesError}
                            className="passportField"
                        />
                    </div>
                </div>

                <Message color='red' icon size='tiny'>
                    <Icon name='warning sign' />
                    <span style={{color: "black"}} dangerouslySetInnerHTML={{__html: getTerm("83641630-d46a-11f0-9cd9-0ac9221eb135", "<strong>Please review your name carefully one more time</strong> and compare to your Passport to ensure you are using the <strong><u>exact same spelling<u></u></u></strong>. Auditors whose name/spelling do not match their passport may be unable to complete auditor qualification requirements.")}}>
                    </span>
                </Message>

                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                    <Button onClick={() => props.setStep("terms")} style={{ visibility: props.allowPrevious ? 'visible' : 'hidden'}}>{getTerm("403eb9da-d787-11f0-9cd9-0ac9221eb135", "Previous Step")}</Button>
                    <Button type='submit' primary>{getTerm("d07f78a4-d13d-11f0-8346-0ac9221eb135", "Next Step")}</Button>
                </div>
            </Form>

            <Confirm
                open={warnings.length > 0}
                header={getTerm("359ab142-daba-11f0-9cd9-0ac9221eb135", "Warning")}
                cancelButton={getTerm("58253eda-daba-11f0-9cd9-0ac9221eb135", "No")}
                confirmButton={getTerm("654a8552-daba-11f0-9cd9-0ac9221eb135", "Yes")}
                content={
                    <ul >
                        {warnings.map(item => <li>{item}</li>)}
                    </ul>
                }
                onCancel={handleCancel}
                onConfirm={handleConfirm}
            />
        </div>
    )
}

export default ReviewPassport;